export const border = {
  'with-border': {
    border: "1px solid",
    borderColor: "gray.200",
    borderRadius: "14px",
  },
  'with-dashed-border': {
    border: "1px dashed",
    borderRadius: "14px",
  },
  'with-border-radius-small': {
    borderRadius: "6px",
  },
  'with-brand-border': {
    borderColor: 'brand.500',
  }
};
